<template>
  <div class="oldTreeEvaluatePage">
    <div class="evaluateBox">
      <van-row gutter="20" class="itemBox">
        <van-col
          v-for="item in listData"
          :key="item.id"
          class="itemList"
          @click="addGoodNumber(item)"
        >
          {{ item.evaluateName }}
          <van-icon
            :info="`${
              parseFloat(item.num) > 99 ? (item.num = '99+') : item.num
            }`"
            v-if="item.num != '0'"
            class="goodNumber"
          />
        </van-col>
      </van-row>
      <!-- <a herf="javascript:void(0);" class="addItem" @click="addItem">我要补充...</a> -->
    </div>
    <!-- 弹出层 -->
    <!-- <van-dialog v-model="addItemShow" title="添加评价" show-cancel-button @confirm="saveUserEvaluateValue"
            @close="closePicker">
            <van-field v-model="UserEvaluateValue" rows="2" autosize type="textarea" maxlength="10" placeholder="请输入评价"
                show-word-limit />
    </van-dialog>-->
  </div>
</template>
<script>
/*eslint-disable*/

// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "oldTreeEvaluate",
  data() {
    return {
      userPoint: {},
      ordTreeId: "",
      objId: "",
      listData: [],
      UserEvaluateValue: "", //用户添加的评价
      addItemShow: false,
      clientType: "", //手机类型
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      this.objId = this.$route.query.commonId;
      if (this.objId == undefined) {
        this.objId = this.dataInfo.id;
      }

      window.setUserPoint = this.setUserPoint;
      this.getAppPoint();
      this.getTreeId();
    });
  },
  methods: {
    getTreeId() {
      let _this = this;
      _this.$api.universal.oldTree
        .oldTreeMsg({
          objid: _this.objId,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.oldTreeId = res.data.id;
            _this.initPage();
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    initPage() {
      let _this = this;
      _this.$api.universal.oldTree
        .GuShuEvaluateDetail({
          treeId: _this.oldTreeId,
          year: "",
        })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.listData = Object.assign({}, _this.listData, res.data);
            for (let i = 0; i < _this.listData.length; i++) {
              _this.listData.addGoodType = true;
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addGoodNumber(data) {
      let _this = this;
      //interiorPoint  需要安卓IOS交互返回当前位置
      if (data.addGoodType == false) {
        _this.$toast(_this.$t("common.moreClickToastMsg"));
      } else {
        data.addGoodType = false;
        if (data.isEvaluate) {
          //取消点赞
          let dto = {
            evaluate: data.evaluate,
            point: _this.userPoint,
            treeId: _this.oldTreeId,
            type: "2",
          };

          _this.$api.universal.oldTree
            .addGuShuEvaluate(dto)
            .then((res) => {
              if (res.code == "1") {
                console.log(res.data);
                if (parseFloat(data.num) < 0 || parseFloat(data.num) == 0) {
                  data.num = 0;
                } else {
                  data.num = parseFloat(data.num) - 1;
                }
                data.isEvaluate = false;
                _this.$toast(_this.$t("common.qxEvaluateTit"));
              } else {
                console.log(res.msg);
                _this.$toast(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          //新增点赞
          let dto = {
            evaluate: data.evaluate,
            point: _this.userPoint,
            treeId: _this.oldTreeId,
            type: "1",
          };

          _this.$api.universal.oldTree
            .addGuShuEvaluate(dto)
            .then((res) => {
              if (res.code == "1") {
                console.log(res.data);
                if (data.num == "0" || data.num == "") {
                  data.num = 1;
                } else {
                  data.num = parseFloat(data.num) + 1;
                }
                data.isEvaluate = true;
                _this.$toast(_this.$t("common.cgEvaluateTit"));
              } else {
                console.log(res.msg);
                _this.$toast(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
        setTimeout(function () {
          data.addGoodType = !data.addGoodType;
        }, 5000);
      }
    },
    getAppPoint() {
      //获取用户当前的位置
      let data = {};
      if (this.clientType == "android") {
        console.log("ssss===");
        window.android.getInfo(117);
      } else {
        window.webkit.messageHandlers.getUserPoint.postMessage({
          callBack: "setUserPoint", //回调 必传
        });
      }
    },
    setUserPoint(data) {
      if (this.clientType == "android") {
        console.log(data);
        let cord = data.split(" ");
        if (cord.length == 2) {
          this.userPoint.x = cord[0];
          this.userPoint.y = cord[1];
        }
      } else {
        let dataObj = JSON.parse(data);
        this.userPoint.x = dataObj.lon;
        this.userPoint.y = dataObj.lat;
      }
    },
  },
  watch: {
    dataInfo: {
      handler: function () {
        let _this = this;
        _this.objId = this.dataInfo.id;
        _this.getTreeId();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.oldTreeEvaluatePage {
  width: 100%;
  height: 100%;

  .evaluateBox {
    width: 100%;
    padding: 8px 16px 0;

    .itemBox {
      width: 100%;

      .itemList {
        position: relative;
        padding: 0 20px !important;
        height: 40px;
        line-height: 40px;
        border: 1px solid #f6f6f6;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        margin: 10px 3%;
        text-align: center;
        font-size: 14px;
        color: #333;

        .goodNumber {
          display: inline-block;
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }

    .addItem {
      display: inline-block;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #f6f6f6;
      border-radius: 8px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      margin: 10px 3% 10px 0;
      text-align: center;
      font-size: 14px;
      color: #333;
    }
  }
}
</style>